import di from 'di';
import coreServices from 'js-core/js/bootstrap/services';
import Authentication from 'js-core/js/plugins/Authentication';

import EmailAccountType from 'app/auth/EmailAccountType';

export default function() {

    // Core
    coreServices();

    // Auth
    di.factory('auth', () => {

        const auth = new Authentication();
        auth.setSessionKey('session-admin');
        auth.registerAccountType(EmailAccountType.NAME, new EmailAccountType);

        auth.restoreSession();

        return auth;
    });
}
